import { render } from "./QuestionSet.vue?vue&type=template&id=32d5a717&scoped=true"
import script from "./QuestionSet.vue?vue&type=script&lang=ts"
export * from "./QuestionSet.vue?vue&type=script&lang=ts"

import "./QuestionSet.vue?vue&type=style&index=0&id=32d5a717&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-32d5a717"

export default script